import { render, staticRenderFns } from "./SlideView.vue?vue&type=template&id=feb08e14&scoped=true"
import script from "./SlideView.vue?vue&type=script&lang=js"
export * from "./SlideView.vue?vue&type=script&lang=js"
import style0 from "./SlideView.vue?vue&type=style&index=0&id=feb08e14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb08e14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feb08e14')) {
      api.createRecord('feb08e14', component.options)
    } else {
      api.reload('feb08e14', component.options)
    }
    module.hot.accept("./SlideView.vue?vue&type=template&id=feb08e14&scoped=true", function () {
      api.rerender('feb08e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SlideView.vue"
export default component.exports